import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// "Compare series" table of the product card. Rows are the parameters flagged "show in series comparison"
// in the admin panel (series[*].comparison, the same rows for every series); a row empty for every series
// is hidden, an empty cell shows a dash.
const EMPTY_CELL = '—';

const TableSeriesComparison = function(props) {
  const { series } = props;

  const { t } = useTranslation();

  const items = useMemo(() => {
    return Object.values(series || {})
      .sort((a, b) => a.priority > b.priority ? 1 : -1);
  }, [series]);

  const rows = useMemo(() => {
    const valueOf = (item, alias) => (item.comparison || []).find((row) => row.alias === alias)?.value ?? null;

    return (items[0]?.comparison || [])
      .filter((row) => items.some((item) => valueOf(item, row.alias) !== null))
      .map((row) => ({
        ...row,
        values: items.map((item) => valueOf(item, row.alias)),
      }));
  }, [items]);

  return (
    <div className={'table'}>
      <div className={'table_container'}>
        <div className={'labels_wrapper'}>
          <div className={'top'}>
            <div>
              <span>{t('label_param')}</span>
            </div>
          </div>
          <div className={'body'}>
            {rows.map((row) => (
              <div key={row.alias}>
                <span>{row.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={'parameters_container'}>
          <div className={'parameters_wrapper'}>
            {items.map((item, i) => (
              <div className={'parameters'} key={i} style={{ textAlign: 'center' }}>
                <div className={'top'}>
                  <div>
                    <span>{item.label}</span>
                  </div>
                </div>
                <div className={'body'}>
                  {rows.map((row) => (
                    <div key={row.alias}>
                      <span>{row.values[i] ?? EMPTY_CELL}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableSeriesComparison;
